import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'parental-student-academic-year'
const initialState = {
  list: null,
  count: null,
}

export const search = createApiAction(
  'academic/parental-student-academic-year/search',
  client.search('/api/academic/parent/student/:studentId/academic-year'),
)

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(search.fulfilled, (state, action) => {
      state.list = action.payload
    })
  },
})

export default sessionSlice.reducer
